(() => {
  'use strict';
  function initialize(root = document) {
    const gallery = root.querySelector('[data-product-gallery]');
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const image = gallery.querySelector('#mainImg');
    const stage = gallery.querySelector('[data-gallery-stage]');
    const thumbs = [...gallery.querySelectorAll('[data-image-url]')];
    if (!image || !thumbs.length) return;
    let index = Math.max(0, thumbs.findIndex(button => button.classList.contains('active')));
    let start;
    const update = () => {
      thumbs.forEach((button, i) => { button.classList.toggle('active', i === index); button.setAttribute('aria-pressed', String(i === index)); });
      const count = gallery.querySelector('[data-gallery-current]');
      if (count) count.textContent = index + 1;
    };
    const show = next => {
      index = (next + thumbs.length) % thumbs.length;
      const button = thumbs[index];
      image.srcset = button.dataset.imageSrcset;
      image.src = button.dataset.imageUrl;
      image.alt = button.dataset.imageAlt;
      update();
      const rail = button.parentElement;
      rail.scrollTo({left:button.offsetLeft - rail.offsetLeft - (rail.clientWidth - button.clientWidth) / 2, behavior:'auto'});
    };
    thumbs.forEach((button, i) => button.addEventListener('click', () => show(i)));
    gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
    stage.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowLeft' ? -1 : 1)); }
    });
    stage.addEventListener('touchstart', event => { const touch = event.changedTouches[0]; start = {x:touch.clientX,y:touch.clientY}; }, {passive:true});
    stage.addEventListener('touchcancel', () => { start = null; }, {passive:true});
    stage.addEventListener('touchend', event => {
      if (!start) return;
      const touch = event.changedTouches[0], dx = touch.clientX - start.x, dy = touch.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
    }, {passive:true});
    document.addEventListener('plumerive:variant', event => {
      const next = thumbs.findIndex(button => button.dataset.imageId === event.detail.imageId);
      if (next >= 0) show(next);
    });
    update();
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
